import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';

const state = {
    crear: {
        cliente: {
            nombre: '',
            apellido: '',
            celular: '',
            whatsapp: '',
            whatsapp_checked: false,
            email: '',
            ubicacion_id: '',
            ubicacion_name: '',
            clientes: [],
            fillCliente: false
        },
        necesidad: {
            id_asesor: '',
            canal: '',
            origen: '',
            presupuesto: 0,
            fecha_cita: ''
        },
        vehiculo: {
            id_marca : '',
            id_modelo : '',
            id_linea : '',
            id_modelorel: '',
            color_primario: '',
            kilometraje: 0,
            id_asesor: '',
            canal: '',
            origen: ''
        },
        errors: {
            "cliente.nombre": '',
            "cliente.apellido": '',
            "cliente.email": '',
            "cliente.celular": '',
            "cliente.ubicacion_name": '',
            "vehiculo.id_marca": '',
            "vehiculo.id_modelo": '',
            "vehiculo.id_linea": '',
            "vehiculo.id_modelorel": '',
            "vehiculo.id_asesor": '',
        },
        impuestos: {

        }
    },
    vender: {
        id_venta: '',
        comprador: {
            nombre: '',
            apellido: '',
            tipo_documento: '',
            numero_documento: '',
            celular: '',
            correo: '',
            ubicacion_id: '',
            ubicacion_name: '',
            direccion: ''
        },
        negocio: {
            precio_publicacion: 0,
            tipo_pago: [],
            comprador: {
                descuento: 0,
                precio_compra: 0,
                forma_pago: ""
            },
            vendedor: {
                descuento: 0,
                precio_venta: 0,
                forma_pago: ""
            }
        },
        vehiculo: {
            fecha_peritaje: '',
            empresa_peritaje: ''
        },
        id_asesor: '',
        id_sede: '',
        vendedor: '',
        id_sede: '',
        vendedorData:{
            nombre: '',
            apellido: '',
            celular: '',
            correo: '',
            ubicacion_id: '',
            ubicacion_name: '',
            direccion: '',
            tipo_documento: '',
            numero_documento: ''
        },
        compradores: [],
        cedula_comprador_link: '',
        openModalComprador: true,
    }
};
const mutations = {
    updateField
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    getters
}
